import request from '@/utils/request'

let Course_courseApi = {

 getJzList(data) {
    return request._post('/shop/plus.course_course.Index/getdatecourse', data);
},
  /*社会就业课程列表*/
  list(data) {
    return request._post('/shop/plus.course_course.Index/index', data);
},
/*添加社会就业课程*/
add(data) {
    return request._post('/shop/plus.course_course.Index/add', data);
},
/*修改社会就业课程*/
edit(data) {
    return request._post('/shop/plus.course_course.Index/edit', data);
},
/*删除社会就业课程*/
del(data) {
    return request._post('/shop/plus.course_course.Index/del', data);
},
/*社会就业课程详情*/
detail(data) {
  return request._post('/shop/plus.course_course.Index/detail', data);
},
    saveSetting(data, errorback) {
        return request._post('/shop/plus.course_course.Setting/getSetting', data, errorback);
    },
    getSetting(data, errorback) {
        return request._get('/shop/plus.course_course.Setting/getSetting', data, errorback);
    },
}
export default Course_courseApi;



// WEBPACK FOOTER //
// ./src/api/course_course.js